import {SessionsApiBase} from './paymentApi';

class SessionsApi extends SessionsApiBase {
}

export default new SessionsApi();
